/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import UiBookingFooterV1Component from 'uplisting-frontend/components/ui/booking/footer/v1';

export default class UiBookingFooterV2Component extends UiBookingFooterV1Component {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Footer::V2': typeof UiBookingFooterV2Component;
  }
}
